import { type Context, type ReactNode, createContext, useContext, useEffect, useState } from 'react'

import { getUser } from '@/repositories/userRepository.ts'

type UserContextType = {
  user: Member | null
  setUser: (user: Member | null) => void
  apiKey: string | null
  isLoading: boolean
}

export const UserContext = createContext<UserContextType | null>(null)

export const UserProvider = (props: { children: ReactNode }) => {
  const [user, setUser] = useState<Member | null>(null)
  const [apiKey, setApiKey] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getUser()
      .then((r) => {
        setUser(r)
        setApiKey(r.apiKey)
      })
      .catch(() => {
        setUser(null)
        setApiKey(null)
      })
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        apiKey,
        isLoading,
      }}
    >
      {props.children}
    </UserContext.Provider>
  )
}

// biome-ignore lint/style/noNonNullAssertion: This is guaranteed to be non-null
export const useUserContext = () => useContext(UserContext as Context<UserContextType>)!
